import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import ProfileSection from "./sections/ProfileSection";
import BillingSection from "./sections/BillingSection";
import "./AccountSettings.css";

const TABS = [
  { path: "/profile", label: "Profile" },
  { path: "/billing", label: "Billing" },
];

export default function AccountSettings() {
  const location = useLocation();
  const section = location.pathname === "/billing" ? "billing" : "profile";

  const renderSection = () => {
    switch (section) {
      case "profile":
        return <ProfileSection />;
      case "billing":
        return <BillingSection />;
      default:
        return <ProfileSection />;
    }
  };

  return (
    <div className="account-settings-page">
      <header className="account-settings-header">
        <h1 className="account-settings-header-title">Account Settings</h1>
        <nav className="account-settings-tabs">
          {TABS.map(({ path, label }) => (
            <NavLink
              key={path}
              to={path}
              className="account-settings-tab"
              activeClassName="active"
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="account-settings-main">{renderSection()}</main>

      <footer className="account-settings-footer">
        <span className="account-settings-copyright">© 2026 Hooptie</span>
        <div className="account-settings-footer-links">
          <NavLink to="/terms-of-service">Terms</NavLink>
          <NavLink to="/privacy-policy">Privacy</NavLink>
        </div>
      </footer>
    </div>
  );
}
